// ----------------------------------------------------------------------
// <copyright file="Izenda.TileTitleBackSide.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var EventsUtils = require('EventUtils');
  var Input = require('share/components/controls/Izenda.Input');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var action = require('./Izenda.TileTitleBackSideAction');

  var CONSTANTS = require('logic/data/Izenda.DashboardConstants');
  var localizer = require('share/localization/Izenda.Localizer');

  var TileSimpleInput = connect(action)(function (props) {
    var LABEL_TEXT = CONSTANTS.TILE_LABEL_TEXT;
    return (
        <GridLayout.Row>
          <GridLayout.Col cols={1}>
            {LABEL_TEXT[props.dataKey]}
          </GridLayout.Col>
          <GridLayout.Col cols={11}>
            <div className="izenda-DashboardTitle-TileTitleBackSide-Input">
              {props.children}
              <a onClick={props.openPopup} title={props.title}><span className="icon-setting" /></a>
            </div>
          </GridLayout.Col>
        </GridLayout.Row>
    );
  });

  TileSimpleInput.propTypes = {
    dashboardPart: React.PropTypes.object.isRequired,
    dataKey      : React.PropTypes.string.isRequired,
    title        : React.PropTypes.string
  };

  var TileTitleBackSide = connect()(function (props) {
    var dashboardPart = props.dashboardPart;

    return (
        <GridLayout className="izenda-DashboardTile-TileTitleBackSide">
          <TileSimpleInput {...props} dataKey="contentTitle" title={localizer.getText('DASHBOARD_LABEL_TITLE_SETTINGS')} >
            <Input
                className="form-control"
                maxLength={CONSTANTS.TITLE_MAX_LENGTH}
                value={dashboardPart.contentTitle.text}
                onChange={EventsUtils.notifyChange(dashboardPart.updateContentTitle.bind(dashboardPart), EventsUtils.INPUT)} />
          </TileSimpleInput>
          <TileSimpleInput {...props} dataKey="contentDescription" title={localizer.getText('DASHBOARD_LABEL_DESCRIPTION_SETTINGS')} >
            <textarea
                className="form-control"
                rows="4"
                value={dashboardPart.contentDescription.text}
                onChange={EventsUtils.notifyChange(dashboardPart.updateContentDescription.bind(dashboardPart), EventsUtils.INPUT)} />
          </TileSimpleInput>
        </GridLayout>
    );
  });

  TileTitleBackSide.propTypes = {
    dashboardPart: React.PropTypes.object.isRequired
  };

  module.exports = TileTitleBackSide;
}());



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Izenda.TileTitleBackSide.jsx